module.exports = __webpack_public_path__ + "media/images/favicon/favicon-32x32-a2aa6b2ccb5d09a0b3ad27941c5f5c68.png";